<template>
  <b-overlay :show="isLoading">
    <line-chart :data="chartData"/>
  </b-overlay>
</template>

<script>
import {mapActions, mapGetters} from 'vuex'

export default {
  name: 'PerformancePanel',
  props: {
    hourAgo: {
      Number,
      default: 8
    }
  },
  data() {
    return {
      time: '',
      oldValueHour: 8
    }
  },
  computed: {
    ...mapGetters({
      performance: 'performance/all',
      isLoading: 'performance/isLoading'
    }),
    chartData() {
      const data = []
      if (this.performance && this.performance.length > 0) {
        this.performance.forEach(element => {
          let vnsName = element.name
          delete element.name
          delete element.id
          data.push({
            name: vnsName,
            data: element
          })
        })
      }
      return data
    }
  },
  methods: {
    ...mapActions([
      'performance/listAll'
    ])
  },
  mounted() {
    this['performance/listAll']({hourAgo: this.hourAgo})
    this.timer = setInterval(() => {
      if (!this.isLoading) {
        this['performance/listAll']({hourAgo: this.hourAgo})
      }
    }, 40000)

    this.changeTimer = setInterval(() => {
      if (this.oldValueHour !== this.hourAgo && !this.isLoading) {
        this.oldValueHour = this.hourAgo
        this['performance/listAll']({hourAgo: this.hourAgo})
      }
    }, 1000)
  },
  beforeDestroy() {
    clearInterval(this.timer)
    clearInterval(this.changeTimer)
  }
}
</script>

<style lang='css'>
.small {
  max-width: 800px;
  /* max-height: 500px; */
  margin: 20px auto;
}
</style>
